import { render, staticRenderFns } from "./EChartsHorizontalBar.vue?vue&type=template&id=4dea56fb&scoped=true"
import script from "./EChartsHorizontalBar.vue?vue&type=script&lang=js"
export * from "./EChartsHorizontalBar.vue?vue&type=script&lang=js"
import style0 from "./EChartsHorizontalBar.vue?vue&type=style&index=0&id=4dea56fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea56fb",
  null
  
)

export default component.exports